/**
 * Formats a currency amount for display using Intl.NumberFormat.
 * Handles Stripe's smallest-unit convention (e.g., cents for USD).
 *
 * @param amount - Amount in smallest currency unit (e.g., cents)
 * @param currency - ISO 4217 currency code (e.g., "usd", "eur")
 * @param options - Optional formatting options
 * @returns Formatted currency string (e.g., "$29.99")
 */
export function formatCurrency(
  amount: number,
  currency: string,
  options?: {
    locale?: string;
    fromSmallestUnit?: boolean; // Default: true (divide by 100)
  }
): string {
  const { locale, fromSmallestUnit = true } = options ?? {};
  const displayAmount = fromSmallestUnit ? amount / 100 : amount;
  // Default to USD if currency is empty or undefined
  const currencyCode = currency || "USD";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  }).format(displayAmount);
}
